import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import { Toaster } from 'react-hot-toast'
import { AuthProvider } from '@/contexts/AuthContext'
import { Header } from '@/components/layout/Header'
// import { AdBanner } from '@/components/ads/AdBanner'
import { logPageView } from '@/utils/analytics'
import { Home } from '@/pages/Home'
import { MyWishlists } from '@/pages/MyWishlists'
import { WishlistView } from '@/pages/WishlistView'
import { SharedWishlist } from '@/pages/SharedWishlist'
import { MyReservations } from '@/pages/MyReservations'
import { SecretSantaList } from '@/pages/SecretSantaList'
import { SecretSantaView } from '@/pages/SecretSantaView'
import { SecretSantaAssignment } from '@/pages/SecretSantaAssignment'
import { Privacy } from '@/pages/Privacy'
import { Terms } from '@/pages/Terms'
import { Cookies } from '@/pages/Cookies'

/**
 * Component that tracks page views on route changes
 */
function AnalyticsTracker() {
  const location = useLocation()

  useEffect(() => {
    // Track page view whenever the route changes
    logPageView(location.pathname + location.search, document.title)
  }, [location])

  return null
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AnalyticsTracker />
        <Header />
        {/* <div className="bg-gray-50 border-b border-gray-200">
          <div className="max-w-7xl mx-auto px-4 py-2">
            <AdBanner format="horizontal" className="w-full" />
          </div>
        </div> */}
        <Routes>
          <Route path="/" element={<Home />} />

          {/* Public Routes */}
          <Route path="/w/:wishlistId" element={<SharedWishlist />} />
          <Route path="/secret-santa/:accessToken" element={<SecretSantaView />} />
          <Route path="/secret-santa/:accessToken/assignment" element={<SecretSantaAssignment />} />

          {/* Legal Pages */}
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/cookies" element={<Cookies />} />

          {/* User Routes - Now accessible to all, pages handle auth state */}
          <Route path="/wishlists" element={<MyWishlists />} />
          <Route path="/wishlists/:id" element={<WishlistView />} />
          <Route path="/reservations" element={<MyReservations />} />
          <Route path="/secret-santa" element={<SecretSantaList />} />
        </Routes>
        <Toaster position="top-right" />
      </AuthProvider>
    </Router>
  )
}

export default App
